module.exports = __webpack_public_path__ + "img/logo-app.6b3d3df7.png";